export type HomeCardId =
  | 'recent-jobs'
  | 'dashboards'
  | 'quick-links'
  | 'help'
  | 'releases';

export interface HomeCardConfig {
  id: HomeCardId;
  label: string;
  icon: string;
  permission?: string;
  defaultVisible: boolean;
}

export const HOME_CARDS: HomeCardConfig[] = [
  { id: 'quick-links', label: 'Quick Links', icon: 'pi pi-th-large', defaultVisible: true },
  { id: 'dashboards', label: 'Dashboards', icon: 'pi pi-chart-line', defaultVisible: true },
  { id: 'help', label: 'Help & Support', icon: 'pi pi-question-circle', defaultVisible: true },
  { id: 'recent-jobs', label: 'Recent Jobs', icon: 'pi pi-briefcase', defaultVisible: true },
  { id: 'releases', label: 'Latest Releases', icon: 'pi pi-history', defaultVisible: true },
];

const STORAGE_KEY = 'home-cards-config';

export interface SavedCardState {
  id: HomeCardId;
  visible: boolean;
  order: number;
}

export function loadCardStates(): SavedCardState[] | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) { return null; }
    return JSON.parse(raw) as SavedCardState[];
  } catch {
    return null;
  }
}

export function saveCardStates(states: SavedCardState[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(states));
  } catch {
    // ignore quota errors
  }
}

export function getDefaultCardStates(configs: HomeCardConfig[], visibleCards: HomeCardConfig[]): SavedCardState[] {
  return configs.map((c, i) => ({
    id: c.id,
    visible: visibleCards.some((vc) => vc.id === c.id),
    order: i,
  }));
}